type IdleCallback = () => void;

type IdleHandle = {
    cancel: () => void;
};

export type IdleScheduler = {
    schedule: (callback: IdleCallback) => void;
    cancel: () => void;
};

function scheduleWhenIdle(callback: IdleCallback, timeout: number): IdleHandle {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        const idleCallbackId = window.requestIdleCallback(callback, {timeout});

        return {
            cancel: () => {
                window.cancelIdleCallback(idleCallbackId);
            },
        };
    }

    const timeoutId = globalThis.setTimeout(callback, 0);
    return {
        cancel: () => {
            globalThis.clearTimeout(timeoutId);
        },
    };
}

export function createIdleScheduler(timeout: number): IdleScheduler {
    let pending: IdleHandle | null = null;

    return {
        schedule(callback: IdleCallback) {
            pending?.cancel();
            pending = scheduleWhenIdle(() => {
                pending = null;
                callback();
            }, timeout);
        },
        cancel() {
            pending?.cancel();
            pending = null;
        },
    };
}
